import React, { useCallback, useEffect } from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { PortfolioList, ProjectFilter, SEOTags } from '@components';
import './Portfolio.scss'
import { useProjectsState } from '@contracts/hooks/useProjects';
import { seoTags } from '@/seo-content';
import { useSearchParams } from '@hooks/useSearchParams';
import { NetworkId } from '@firestarter-private/firestarter-library/lib/constants';
import { projectFilterItems } from '@pages/Projects';
import { useWalletContext } from '@firestarter-private/firestarter-library'

export const Portfolio = () => {
  const { account } = useWalletContext()

  const {
    loading,
    whitelistedProjects: projects,
    getWhitelistedProjects,
    abortRequest
  } = useProjectsState()

  const {
    query,
    replaceQuery
  } = useSearchParams()

  const changeFilter = useCallback((value: NetworkId | 'all') => {
    if (value === 'all') {
      return replaceQuery({})
    }
    replaceQuery({ chainId: value })
  }, [replaceQuery])

  const loadProjects = useCallback(async () => {
    abortRequest()
    await getWhitelistedProjects(query)
  }, [abortRequest, getWhitelistedProjects, query])

  useEffect(() => {
    loadProjects()
  }, [account, query])

  return (
    <div className="portfolio-page">
      <section className='filters-section'>
        <Container>
          <Navbar className='filters-section__row'>
            <span className='projects-title'>Projects:</span>
            <ProjectFilter
              name=''
              value={query.chainId ?? 'all'}
              items={projectFilterItems}
              onChange={changeFilter}
            />
          </Navbar>
        </Container>
      </section>
      <section className="account-portfolio">
        <SEOTags {...seoTags.accountPortfolio} />
        <Container>
          <PortfolioList projects={!loading && projects ? projects : undefined} />
        </Container>
      </section>
    </div>
  )
}
